import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { DataService } from "../../core/core-services/services/dataservices/data.service";
import { LoadingService } from "src/app/components/loading/loading.service";

@Injectable()
export class TemplatesResolver  {
  constructor(private dataService: DataService, private loadingService: LoadingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    //this.loadingService.show();

    if (route.params.categoryName) {
      return this.dataService
        .get({
          url:
            "v1/user/templatebyname?skip=0&limit=10&order_by=shortcut,asc" +
            (route.params.categoryName.toLowerCase() === "viewall"
              ? ""
              : "&category_name=" + route.params.categoryName) +
            (route.params.subCategoryName ? "&sub_category_name=" + route.params.subCategoryName : "") +
            (route.params.subSubCategoryName ? "&sub_sub_category_name=" + route.params.subSubCategoryName : ""),
          isLoader: true,
        })
        .pipe(
          finalize(() => {
            //this.loadingService.hide()
          })
        );
    }
    return this.dataService
      .get({
        url:
          "v1/user/template?skip=0&limit=10&order_by=shortcut,asc" +
          (route.params.categoryId === "all" ? "" : "&category_id=" + route.params.categoryId),
        isLoader: true,
      })
      .pipe(
        finalize(() => {
          // this.loadingService.hide()
        })
      );
  }
}
